import { defineComponent as _defineComponent } from 'vue'
import BaseDialog from "@/components/base-dialog.vue";
import WorldXIcon from "@/assets/icons/svg/world-x.icon.svg";
import { useRouter } from "vue-router/composables";


export default /*#__PURE__*/_defineComponent({
  __name: 'editor-get-changes-error-dialog',
  props: {
    isVisible: { type: Boolean },
    onClose: null,
    redirectTo: null
  },
  setup(__props: any) {

const props = __props as {
  isVisible: boolean;
  onClose: () => void;
  redirectTo?: string;
}

const router = useRouter();



const closeDialog = () => {
  props.onClose();

  if (props.redirectTo) {
    router.push(props.redirectTo);
  }
};

return { __sfc: true,router, props, closeDialog, BaseDialog, WorldXIcon }
}

})